import React from "react";
import moment from "moment";
import { SimpleGrid, Group, Stack, Text } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useFormatter } from "../hooks/useFomatter";
import { getInvestmentTransactionStatusLabel } from "../helpers/investmentTransactionStatusLabels";
import { formatTransactionTypesForDisplay } from "../helpers/arFormUtils";
import { McaApprovalListBadge } from "./mca/McaEntityIndicators";

const SummaryField = ({ label, children }) => (
  <Stack spacing={2}>
    <Text transform="uppercase" size="xs" weight={600} color="gray.7">
      {label}
    </Text>
    {children}
  </Stack>
);

const OrderInvestmentTransactionStatusHeader = ({ form }) => {
  const { t } = useTranslation();
  const [formatter] = useFormatter();
  const values = form?.values ?? {};
  const { code, status, createdAt, arForm } = values;

  if (!code && !values._id) return null;

  const transactionType = formatTransactionTypesForDisplay(
    arForm?.transactionType
  );
  const investmentAmount =
    arForm?.investmentAmount != null
      ? formatter.currency(arForm.investmentAmount, "HKD")
      : "—";

  return (
    <SimpleGrid
      cols={5}
      spacing="md"
      breakpoints={[
        { maxWidth: "md", cols: 2 },
        { maxWidth: "xs", cols: 1 },
      ]}
      sx={{ width: "100%" }}
    >
      <SummaryField label={t("Transaction No.")}>
        <Text size="sm">{code || "—"}</Text>
      </SummaryField>

      <SummaryField label={t("Transaction Type")}>
        <Text size="sm">{transactionType || "—"}</Text>
      </SummaryField>

      <SummaryField label={t("Investment Amount")}>
        <Text size="sm">{investmentAmount}</Text>
      </SummaryField>

      <SummaryField label={t("Created")}>
        <Text size="sm">
          {createdAt ? moment(createdAt).format("YYYY-MM-DD") : "—"}
        </Text>
      </SummaryField>

      <SummaryField label={t("Status")}>
        <Group spacing="xs">
          <Text size="sm">
            {status ? getInvestmentTransactionStatusLabel(status, t) : "—"}
          </Text>
          <McaApprovalListBadge entity={values} />
        </Group>
      </SummaryField>
    </SimpleGrid>
  );
};

export default OrderInvestmentTransactionStatusHeader;
